function parseNumber(value) {
    const parsed = parseFloat(String(value || ''));
    return Number.isFinite(parsed) ? parsed : 0;
}

export function formatCoverSurchargeDollarHint(baseAmount, rate) {
    const base = parseNumber(baseAmount);
    const surchargeRate = parseNumber(rate);
    if (surchargeRate <= 0 || base <= 0) {
        return '';
    }
    const surcharge = Math.round(base * surchargeRate * 100) / 100;
    return formatCoverSurchargeAmountHint(surcharge);
}

export function formatCoverSurchargeAmountHint(amount) {
    return ' (+$' + parseNumber(amount).toFixed(2) + ')';
}
